import type { SiteContent } from '@/types/site-content';

export const DEFAULT_SITE_CONTENT: SiteContent = {
  heroTitle: 'Get your ski pass in 3 clicks',
  faqItems: [
    {
      id: 'book-ski-passes',
      question: 'How can I book ski passes?',
      answer:
        'Enter your transfer booking reference in the form above, add an optional promo code, and click "Book ski pass". You\'ll be guided through selecting the right pass and completing payment.',
    },
    {
      id: 'find-reference',
      question: "I can't find my booking reference. What should I do?",
      answer:
        'Check your booking confirmation email from Alps2Alps. If you still can\'t locate it, click "Forget your booking reference? Click here" on the booking form and we\'ll help you recover it.',
    },
    {
      id: 'without-reference',
      question: 'Can I book ski passes without a booking reference?',
      answer:
        'Ski passes are available exclusively as part of the Alps2Alps transfer booking process. A booking reference is required to proceed.',
    },
    {
      id: 'receive-pass',
      question: 'How will I receive my ski pass?',
      answer:
        'After completing payment you\'ll receive a booking confirmation. Your QR code will be emailed up to 7 days before your trip. Scan it at any ticket machine at the lift station to collect your physical ski pass.',
    },
    {
      id: 'print-voucher',
      question: 'Do I need to print my voucher?',
      answer:
        'No printing is needed. Simply present the digital QR code on your phone at a self-service ticket machine, or show your confirmation email at the ticket office.',
    },
    {
      id: 'change-details',
      question: 'Can I change skier details after booking?',
      answer:
        'Changes may be possible up to 8 days before your ski pass start date. After that window you will need to visit the resort ticket office in person.',
    },
    {
      id: 'children-passes',
      question: 'Can I book free ski passes for children online?',
      answer:
        "Yes – where the resort offers free children's passes, you can add them during the booking process at no extra charge.",
    },
  ],
  footer: {
    companyDisplayName: 'Alps2Alps Ltd',
    locationBlock: `7 Bell Yard, London, England, WC2A 2JR, UK
+44 (0) 20 3701 7961

Route de Montena 7, c/o FIDUVISION SA 1728 Rossens FR
+33 (0) 1 78 90 26 11

Merchant location: 22 Addiscombe Road Croydon CR0 5PE UK`,
    linkSections: [
      {
        title: 'Support',
        links: [
          { label: 'FAQs', href: 'https://www.alps2alps.com/faq-ski-transfers/' },
          { label: 'Contact Support', href: 'https://www.alps2alps.com/contact/' },
        ],
      },
      {
        title: 'Legal',
        links: [
          { label: 'Terms & Conditions', href: '/terms-and-conditions' },
          { label: 'Privacy Policy', href: 'https://www.alps2alps.com/privacy/' },
          { label: 'Refund & Cancellation Policy', href: 'https://www.alps2alps.com/cancellation-policy/' },
        ],
      },
    ],
  },
};
